import styled from "styled-components";
import { SuccessButton } from "../styles/button";
import { Modal } from "./modal";
import { useState } from "react";

const COOKIES_KEY = "marjo90rie-cookies";

function fetchCookies() {
  try {
    return JSON.parse(localStorage.getItem(COOKIES_KEY) ?? "false");
  } catch {
    return false;
  }
}

export function Cookies() {
  const [isAccepted, setIsAccepted] = useState(fetchCookies());

  if (isAccepted) {
    return <></>;
  }
  return (
    <Modal>
      <ModalContainer>
        <div>Veuillez accepter les cookies</div>
        <SuccessButton
          onClick={() => {
            setIsAccepted(true);
            localStorage.setItem(COOKIES_KEY, JSON.stringify(true));
          }}
        >
          Accepter
        </SuccessButton>
      </ModalContainer>
    </Modal>
  );
}

const ModalContainer = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  gap: 15px;
`;
